import React from "react";
import { useEffect, useRef, useState } from "react";
import { ineVerificate } from "../../api/ineVerificate";
import folder from '../../assets/folder.svg';
import file from '../../assets/file.svg';
import shield from '../../assets/shield.svg';
import scanner from '../../assets/scanner.svg';
import './style.css';

function Pantalla49Lic() {

    const isRunned = useRef(false);
    const [dateReco, setDateReco] = useState("");
    const [strStatus, setStrStatus] = useState("");
    const [strOperation, setStrOperation] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            setLoading(false);

            const objIncode = {
                interviewId: localStorage.getItem("interviewIdLic"),
                tokenIncode: localStorage.getItem("tokenIncodeLic"),
            }

            const response = await ineVerificate(objIncode);

            if (response.status === 200) {

                setDateReco(response.dateT);
                setStrOperation("Validación de Licencia de Conducir");
                setStrStatus("Validado");

            }

            setLoading(true);
        }

        createSession();

    }, []);

    return (
        <>
            <div className='containerInfo_P2'>

                {loading ? (
                    <>
                        <div className='containerIdent_P2'>
                            <div className='txtOp_P2'>Operación/Operation</div>
                            <div className='txtVer_P2'>{strOperation}</div>
                            <div className='txtCpv_P2'>Estatus/Status</div>
                            <div className='txtVer_P2'>{strStatus}</div>
                            <div className='txtOp_P2'>Fecha/Date</div>
                            <div className='txtVer_P2'>{dateReco}</div>
                        </div>
                        <div className='containerDoc_P2'>
                            <div className='txtReq_P2'>En esta operación se realizó:</div>
                        </div>
                        <div className='container_data_operation'>
                            <img src={file} align="left" className='imgFol_P2 animate__animated animate__fadeIn' />
                            <div className='txtDocReq_P2'>Validación de integridad</div>
                            <p className='txtIdenOf_P2_6'>Validación de Licencia de Conducir.</p>

                            <img src={shield} align="left" className='imgFol_P2 animate__animated animate__fadeIn' />
                            <div className='txtDocReq_P2'>Confirmación de titularidad</div>
                            <p className='txtIdenOf_P2_6'>Comparación contra Identidad Personal.</p>

                            <img src={folder} align="left" className='imgFol_P2 animate__animated animate__fadeIn' />
                            <div className='txtDocReq_P2'>Confirmación de vigencia</div>
                            <p className='txtIdenOf_P2_6'>Revisión de fecha de expiración.</p>

                            <img src={scanner} align="left" className='imgFol_P2 animate__animated animate__fadeIn' />
                            <div className='txtDocReq_P2'>Autorización de operación</div>
                            <p className='txtIdenOf_P2_6'>Autorización con reconocimiento facial.</p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="containerRender">
                            <div className="spinner"></div>
                        </div>
                    </>
                )}
            </div>
        </>
    )
}
export default Pantalla49Lic
